export default __webpack_public_path__ + "static/media/medium.dc2e500f.svg";